<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 mat-dialog-title>Add map</h2>

  <mat-dialog-content>
    <p>Add a new map to the archive.</p>

    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input type="text" matInput formControlName="title" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button type="submit" [disabled]="!form.valid">Add</button>
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>
</form>
